import React from 'react'
import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react'
import { BrowserRouter , Switch, Route } from 'react-router-dom'
import DossiersListContainer from 'components/dossiers/DossiersListContainer';
import DossiersMenuContainer from 'components/dossiers/DossiersMenuContainer';
import Dossier from 'components/dossiers/Dossier';

export default class Dossiers extends React.Component {
  render () {
    return (
      <div>
        <Switch>
          <Route exact path={Routes.dossiers_path()} component={DossiersListContainer}/>
          <Route path='*/:id' render={ props => (
            <Sidebar.Pushable as={Segment} className= "min-height-90">

              <DossiersMenuContainer/>
              <Sidebar.Pusher className="left-sidebar-margin">
                <Dossier dossierId={props.match.params.id}/>
              </Sidebar.Pusher>
            </Sidebar.Pushable>
           )} />

        </Switch>
      </div>
    )
  }
}

